var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" "+_vm._s(_vm.mwutils.prettyPrint(_vm.item[_vm.column.value], "TITLE"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }